export const BannerInfo = ({ isSuccess = false, isFailure = false, message = "" }) => {

    if (!isSuccess && !isFailure) return (<> </>);

    return (
        <div className="shadow-sm border rounded-md flex w-full justify-between">
            {isSuccess && <div className={`max-w-1 w-1 rounded-tr-md rounded-br-md bg-green-800`} ></div>}
            {isFailure && <div className={`max-w-1 w-1 rounded-tr-md rounded-br-md bg-red-800`} ></div>}
            <div className="w-full py-1.5 px-4">
                <span className="text-sm">{message}</span>
            </div>
        </div>
    )
}